/**
 * @generated SignedSource<<a577dbdccea4cb920e3694a2dc604f0b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PastProposalsFormSectionProposalListFragment$data = {
  readonly allProposals: ReadonlyArray<{
    readonly id: string;
    readonly number: string;
    readonly title: string;
  }>;
  readonly " $fragmentType": "PastProposalsFormSectionProposalListFragment";
};
export type PastProposalsFormSectionProposalListFragment$key = {
  readonly " $data"?: PastProposalsFormSectionProposalListFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"PastProposalsFormSectionProposalListFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PastProposalsFormSectionProposalListFragment",
  "selections": [
    {
      "alias": "allProposals",
      "args": null,
      "concreteType": "OnChainProposal",
      "kind": "LinkedField",
      "name": "onChainProposals",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "number",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "2f9c4a3622044aafcb0abc759c9e6d72";

export default node;
